import { buildDashBoardPath } from "pages/routes";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import useUserData from "repository/useUser";
import Skeleton from "components/atom/Skeleton";

type Props = {
  onChange?: (bId: string) => void;
  currentBID?: string;
};
const BranchSelector: FC<Props> = ({ onChange: _onChange, currentBID }) => {
  const { data, isLoading } = useUserData();
  const navigate = useNavigate();

  const defaultOnChange = (bId: string) => {
    navigate(buildDashBoardPath(bId));
  };
  const onChange = _onChange ?? defaultOnChange;

  if (isLoading) return <Skeleton height={30} />;
  if (
    data &&
    (data.editableBranches.length > 0 || data.visibleBranches.length > 0)
  ) {
    return (
      <div className="select is-small">
        <select value={currentBID} onChange={(e) => onChange(e.target.value)}>
          {/* currentBidが未設定、つまり初期化されていないときは空で初期化する。( 先頭の要素がonChangeで選べないため ) */}
          {currentBID || <option>店舗を選択してください。</option>}
          {data.editableBranches
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((branch) => (
              <option value={branch.bId} key={branch.bId}>
                ✏ {branch.name}
              </option>
            ))}
          {data.visibleBranches
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((branch) => (
              <option value={branch.bId} key={branch.bId}>
                👀 {branch.name}
              </option>
            ))}
        </select>
      </div>
    );
  }

  return <></>;
};
export default BranchSelector;
